import { useMemo } from 'react';
import { DefaultRootState, useSelector } from 'react-redux';

import { TradingType } from 'common/api/autogenerated/client-area';

import { WalletAccountV2DtoExtended } from 'views/wallet-new/redux/wallet.initialState';

export const useWallet = (currencyCode: string | null | undefined, tradingType: TradingType = TradingType.SPOT) => {
  const account = useSelector((state: DefaultRootState) => {
    if (currencyCode && currencyCode in state.walletReducer.wallets)
      return state.walletReducer.wallets[currencyCode]?.accounts?.find((i) => i.accountType === tradingType);

    return undefined;
  });

  const decimalPlaces = useSelector(
    (state: DefaultRootState) =>
      state.walletReducer.currencies.find((_currency) => _currency.code === currencyCode)?.decimalPlaces,
  );

  const wallet: Partial<WalletAccountV2DtoExtended> | undefined = useMemo(
    () => ({ decimalPlaces, ...account }),
    [account, decimalPlaces],
  );

  return wallet;
};
